<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text-h6 font-weight-regular">
              Pappyon Business Portal Access
            </div>
          </v-card-title>
          <v-card-text>
            <BusinessPortalAccess
              :businessProfileId="userProfile.businessProfileId"
              :selectedBusinessProfileId="selectedBusinessProfileId"
              :businessProfile="businessProfile"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BusinessPortalAccess from "@/components/BusinessPortalAccess";
import { mapGetters } from "vuex";

export default {
  name: "Administration",
  components: {
    BusinessPortalAccess,
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "selectedBusinessProfileId",
      "businessProfile",
    ]),
  },
};
</script>